import {Injectable} from '@angular/core';
import {CompanyModel, ProfileActivity, UserInfo} from '../user.model';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../../../src/environments/environment';
import {Observable} from 'rxjs';
import {UsersubscriptionModel} from '../../usersubscription/usersubscription.model';

@Injectable()
export class ProfileApiService {

  private baseUrl = environment.backEndUrlPrefix + '/' + 'db/user';
  private profileUrl = '/profile';

  constructor(private http: HttpClient) {
  }

  public readCurrentCompany(): Observable<CompanyModel> {
    return this.http.get<CompanyModel>(this.baseUrl + this.profileUrl + '/company/current');
  }

  public readCompanies(): Observable<CompanyModel[]> {
    return this.http.get<CompanyModel[]>(this.baseUrl + this.profileUrl + '/company');
  }

  public getActivities(): Observable<ProfileActivity[]> {
    return this.http.get<ProfileActivity[]>(this.baseUrl + this.profileUrl + '/activity');
  }

  public getEvents(): Observable<UsersubscriptionModel[]> {
    return this.http.get<UsersubscriptionModel[]>(this.baseUrl + this.profileUrl + '/event');
  }

  public switchCompany(company: CompanyModel): Observable<any> {
    return this.http.post<{ companyId: number }>(this.baseUrl + this.profileUrl + '/company/switch?companyId=' + company.id, {});
  }

  public readProfile(): Observable<UserInfo> {
    return this.http.get<UserInfo>(this.baseUrl + this.profileUrl);
  }

  updateProfile(userInfo: UserInfo): Observable<UserInfo> {
    return this.http.put<UserInfo>(this.baseUrl + this.profileUrl, userInfo);
  }

  updatePassword(passwordOld: string, passwordNew: string) {
    const body = new HttpParams()
      .set('old_password', passwordOld)
      .set('new_password', passwordNew);

    return this.http.put(this.baseUrl + this.profileUrl + '/password',
      body.toString(),
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
      }
    );
  }
}
